<template>
  <div id="xksCascader">
    <el-cascader
      placeholder="请选择省市信息"
      size="small"
      class="cascader"
      :options="options"
      v-model="innerCity"
      :props="props"
      :show-all-levels="is_levels"
      clearable
      @change="onChange"
    ></el-cascader>
  </div>
</template>

<script>

export default {
  name: "xksCascader",

  // 如果需要支持 .sync 语法，可以加 model 这一行：
  // model: { prop: 'city', event: 'update:city' },

  props: {
    is_levels: {
      type: Boolean,
      default: true,
    },
    city: {
      type: [String, Array],
      default: () => [],
    },
    values: {
      type: Array,
      default: () => [],
    },
    not_area: {
      type: Boolean,
      default: true,
    },
    areaShow: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      // 1. 在 data 里声明一个局部变量 innerCity（初始值来自 prop）
      innerCity: this.city,

      props: {
        multiple: false,
        value: "label",
        emitPath: true,
        checkStrictly: true,
      },
      options: [],
    };
  },

  watch: {
    // 2. 当父组件的 city/values 改变时，同步更新 innerCity
    city(val) {
      this.innerCity = val;
    },
    values(val) {
      this.innerCity = val;
    },
  },

  created() {
    this.axios.get("/api/common/get_area_tree").then((res) => {
      this.options = res.data.map(prov => {
        prov.label = prov.name;
        prov.value = prov.id;
        prov.children = prov.children || [];
        prov.children = prov.children.map(city => {
          city.label = city.name;
          city.value = city.id;
          if (this.areaShow && city.children) {
            city.children = city.children.map(dist => {
              dist.label = dist.name;
              dist.value = dist.id;
              return dist;
            });
          } else {
            city.children = null;
          }
          return city;
        });
        return prov;
      });

      // 初始化 innerCity
      if (this.values && this.values.length) {
        this.innerCity = this.values;
      }
    });
  },

  methods: {
    onChange(val) {
      // 3. 用户在级联组件里选中后，先更新本地 innerCity，再向外触发事件通知父组件
      this.innerCity = val;
      console.log("我是切换的hi三角地啊",val)
      // 如果父组件用了 v-bind:city.sync="xx"，这行会自动帮你同步到父组件
      this.$emit("update:city", val);
      // 保留原来的 confirm 回调
      this.$emit("confirm", val);
    },

    // 如果还要提供外部调用的 API，也都操作 innerCity
    setCity() {
      this.innerCity = "";
      this.$emit("update:city", "");
    },
    setCityValue(data) {
      this.innerCity = data;
      this.$emit("update:city", data);
    },
  },
};
</script>

<style>
.el-cascader-panel {
  height: 300px;
}

.el-cascader-menu__wrap {
  height: 304px;
}

#xksCascader .cascader {
  width: 100%;
}
</style>
